module.exports = __webpack_public_path__ + "img/trading2.212cd1e0.svg";